import React from "react";
import { useTranslation } from 'react-i18next';
import QuarriesBursaOrhaneli from "../Components/quarries/QuarriesBursaOrhaneli";
import TopBar from "../Components/common/TopBar";
import Spacer from "../Components/common/Spacer";
import SEO from "../Components/common/SEO";

function BursaOrhaneliPage() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const seo = {
    title: currentLang === 'tr' ? 'Bursa Orhaneli Ocağı Mermerleri - MOCA Mermer' : 'Bursa Orhaneli Quarry Marbles - MOCA Marble',
    description: currentLang === 'tr' ? 'Bursa Orhaneli mermer ocağından çıkarılan Light Emperador mermer çeşitleri.' : 'Light Emperador marble varieties from Bursa Orhaneli quarry.',
    keywords: currentLang === 'tr' ? 'bursa orhaneli ocak, light emperador, mermer çeşitleri' : 'bursa orhaneli quarry, light emperador, marble varieties'
  };

  return (
    <>
      <SEO 
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/bursaorhaneli"
      />
      <TopBar />
      <Spacer />
      <QuarriesBursaOrhaneli />
    </>
  );
}

export default BursaOrhaneliPage;
